"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
var JobRequisitionLocationDataProvider_1 = require("../shared/JobRequisitionLocationDataProvider");
var SearchFilterMapper_1 = require("../api/SearchFilterMapper");
var CareerSiteUrlProvider_1 = require("../shared/CareerSiteUrlProvider");
var ApiServices = (function () {
    function ApiServices() {
        this.serviceBase = csod.context.serviceBase;
        this.baseUrl = this.serviceBase + "services/x/career-site";
        this.corpSettingsBaseUrl = this.serviceBase + "services/x/corpsettings";
        this.requisitionBaseUrl = this.serviceBase + "services/x/job-requisition";
        this.candidateServiceBaseUrl = this.serviceBase + "services/x/ats-candidate-api/";
        this.jobAlertServiceBaseUrl = csod.context.endpoints.cloud + "rec-job-alerts/";
        this.ouServiceBaseUrl = this.serviceBase + "services/api/OrgUnit/";
        this.userId = csod.context.user;
        this.corp = csod.context.corp;
        this.locationDataProvider = new JobRequisitionLocationDataProvider_1.JobRequisitionLocationDataProvider();
        this.searchFilterMapper = new SearchFilterMapper_1.SearchFilterMapper();
    }
    ApiServices.prototype.getCareerSiteData = function (careerSiteId, cultureId) {
        var url = this.baseUrl + "/v1/careersites/" + careerSiteId;
        if (cultureId) {
            url += "?cultureId=" + cultureId;
        }
        return csod.service.get(url);
    };
    ApiServices.prototype.getJobDetail = function (careerSiteId, reqId, cultureId) {
        var jobDetailServiceUrl = this.requisitionBaseUrl + "/v2/requisitions/" + reqId + "/jobDetails?cultureId=" + cultureId;
        return csod.service.get(jobDetailServiceUrl).then(function (response) {
            return response.data;
        }).catch(function () {
            var defaultJobDetail = {
                displayTitle: "",
                externalDescription: "",
                ref: "",
                jobAd: "",
                primaryLocation: {
                    title: "",
                    locationDisplayTitle: "",
                    geocode: {
                        latitude: "",
                        longitude: ""
                    },
                    city: "",
                    state: "",
                    country: "",
                    postalCode: "",
                    line1: ""
                },
                additionalLocations: new Array()
            };
            return defaultJobDetail;
        });
    };
    ApiServices.prototype.getJobAd = function (careerSiteId, reqId, cultureId) {
        var jobAdServiceUrl = this.serviceBase + "Services/API/ATS/CareerSite/" + careerSiteId + "/JobRequisitions/" + reqId + "?useMobileAd=false&cultureId=" + cultureId;
        return csod.service.get(jobAdServiceUrl).then(function (response) {
            return response.data[0].items[0].fields.ad;
        }).catch(function () {
            return "";
        });
    };
    ApiServices.prototype.getJobPosting = function (careerSiteId, reqId) {
        var careerSiteServiceUrl = this.baseUrl + "/v1/requisition/" + reqId;
        return csod.service.get(careerSiteServiceUrl).then(function (response) {
            return response.data.postings;
        }).catch(function () {
            return "";
        });
    };
    ApiServices.prototype.getCorpSettingValue = function (key) {
        var corpSettingsServiceUrl = this.corpSettingsBaseUrl + "/v1/corpsettings/" + key;
        return csod.service.get(corpSettingsServiceUrl).then(function (response) {
            if (response.data) {
                return response.data.value;
            }
            else {
                return "";
            }
        }).catch(function () {
            return "";
        });
    };
    ApiServices.prototype.getOuLocations = function () {
        var url = csod.context.endpoints.cloud + "rec-job-search/utility/oulocations";
        return csod.service.get(url).then(function (response) {
            if (response.data && response.data.length) {
                return response.data;
            }
        }).catch(function () {
            return "";
        });
    };
    ApiServices.prototype.getOuTitle = function (ouId) {
        var ouServiceUrl = this.ouServiceBaseUrl + "/" + ouId + "/title";
        return csod.service.get(ouServiceUrl).then(function (response) {
            if (response.data && response.data.length) {
                return response.data[0];
            }
            else {
                return "";
            }
        }).catch(function () {
            return "";
        });
    };
    ApiServices.prototype.getApplicantApplyStatus = function (careerSiteId, requisitionId) {
        var applyStatusServiceUrl = this.serviceBase + "Services/API/ATS/CareerSite/" + careerSiteId + "/JobRequisition/" + requisitionId + "/GetRequisitionApplyStatus";
        return csod.service.get(applyStatusServiceUrl).then(function (response) {
            return response.data[0].items[0].fields.applyStatus;
        }).catch(function () {
            return -1;
        });
    };
    ApiServices.prototype.getApplicationWorkflowUrl = function (jobRequisitionId, careerSiteId) {
        var serviceURL = this.serviceBase + "Services/API/ATS/applicationworkflow/CareerSite/" + careerSiteId + "/JobRequisition/" + jobRequisitionId + "/url";
        return csod.service.get(serviceURL);
    };
    ApiServices.prototype.saveJobForUser = function (jobRequisitionId) {
        var isCallSuccessful = false;
        var serviceUrl = this.candidateServiceBaseUrl + "v1/jobapplicants/savejob?jobRequisitionId=" + jobRequisitionId;
        return csod.service.post(serviceUrl).then(function (response) {
            if (response.status === "Success") {
                isCallSuccessful = true;
                return Promise.resolve(isCallSuccessful);
            }
            else {
                return Promise.reject(isCallSuccessful);
            }
        }).catch(function (error) {
            return Promise.reject(isCallSuccessful);
        });
    };
    ApiServices.prototype.saveJobAlert = function (jobAlertRequest) {
        var serviceUrl = this.jobAlertServiceBaseUrl + "v1/job-alerts/external";
        return csod.service.post(serviceUrl, jobAlertRequest).then(function (response) {
            if (response.status === "Success") {
                return Promise.resolve(true);
            }
            else {
                return Promise.reject(false);
            }
        }).catch(function (error) {
            return Promise.reject(false);
        });
    };
    ApiServices.prototype.getSavedJobForUser = function (jobRequisitionId) {
        var serviceUrl = this.candidateServiceBaseUrl + "v1/jobapplicants/SavedJobs/" + jobRequisitionId;
        return csod.service.get(serviceUrl).then(function (response) {
            return response.data;
        }).catch(function (error) {
            console.log(error);
            return false;
        });
    };
    ApiServices.prototype.getUserEmail = function () {
        var serviceUrl = this.candidateServiceBaseUrl + "v1/candidates/GetLoggedInCandidate";
        return csod.service.get(serviceUrl).then(function (response) {
            if (response.data && response.data.emailAddress)
                return response.data.emailAddress;
            else
                return "";
        }).catch(function (error) {
            console.log(error);
            return "";
        });
    };
    ApiServices.prototype.getCustomFields = function (fieldIds) {
        var requestUrl = '';
        if (!fieldIds) {
            fieldIds = [];
        }
        fieldIds.forEach(function (element) {
            requestUrl += "fieldIds=" + element + "&";
        });
        var serviceUrl = this.serviceBase + "services/x/core-customfields-service/v1/CustomFields?" + requestUrl + "respectAvailablity=false&cultureId=" + csod.viewModel.siteSettings.currentLanguageDetail.cultureId;
        return csod.service.get(serviceUrl).then(function (response) {
            return response.data;
        }).catch(function (error) {
            csod.logger.error("Failed to get custom fields: " + error);
            return false;
        });
    };
    ApiServices.prototype.getNewResults = function (searchData) {
        var _this = this;
        var careerSiteUrlProvider = new CareerSiteUrlProvider_1.CareerSiteUrlProvider(csod.context.applicationBase, csod.context.corp, csodPlayerRouteInfo.cid, csod.context.cultureName);
        var routePrefix = careerSiteUrlProvider.getRoutePrefix();
        var isBrowserRouter = csod.viewModel.routerType === 'Browser';
        var url = this.baseUrl + "/v1/search";
        var searchResults = {
            results: new Array(),
            totalSearchResults: 0,
            filters: new Array(),
            customFieldFilters: new Array()
        };
        return csod.service.post(url, searchData).then(function (response) {
            searchResults.results = response.data.requisitions.map(function (r) {
                return {
                    id: r.requisitionId,
                    title: r.displayJobTitle,
                    location: _this.locationDataProvider.getLocationDisplayTitleForSearch(r.locations),
                    jobDetailRelativeURL: isBrowserRouter ?
                        routePrefix + "/requisition/" + r.requisitionId + csod.viewModel.nonCustomFieldParams :
                        "/requisition/" + r.requisitionId
                };
            });
            searchResults.filters = _this.searchFilterMapper.getFilters(response.data.filters, false);
            searchResults.totalSearchResults = response.data.totalCount;
            searchResults.customFieldFilters = _this.searchFilterMapper.getCustomFieldFilters(response.data.customFieldFilters);
            return searchResults;
        }).catch(function (error) {
            console.log(error);
            return searchResults;
        });
    };
    ApiServices.prototype.getKeywordPredictiveSearchResults = function (searchRequest) {
        var url = this.baseUrl + "/v1/predictiveSearch";
        return csod.service.post(url, searchRequest)
            .catch(function (error) {
            console.log(error);
            return {
                data: {
                    suggestions: []
                }
            };
        });
    };
    ApiServices.prototype.locationSearch = function (query, google) {
        var results = {
            results: []
        };
        return new Promise(function (resolve) {
            csod.viewModel.mapsApiService.getPlacePredictions({ input: query, types: ['geocode'] }, function (predictions, status) {
                if (status != google.maps.places.PlacesServiceStatus.OK) {
                    console.log(status);
                    resolve(results);
                }
                results.results = predictions.map(function (p) {
                    return {
                        text: p.description,
                        value: {
                            placeId: p.place_id,
                            name: p.description
                        }
                    };
                });
                resolve(results);
            });
        });
    };
    return ApiServices;
}());
exports.ApiServices = ApiServices;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/f257358f111b2299/src/api/index.ts
// module id = 804
// module chunks = 0